import type { AssignmentFormData } from '../../../types/assignmentTypes';
import NotificationsFormPreview from '../NotificationsFormPreview';
import { useFormContext } from 'react-hook-form';

export default function NotificationsFormPreviewWrapper() {
  const { watch } = useFormContext<AssignmentFormData>();

  const { settings } = watch();

  return <NotificationsFormPreview settings={settings} renderStatus />;
}
